<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 8L0 3.6135L0.707 2.92433L4.5 6.62118L11.293 0L12 0.689168L4.5 8Z" fill="#4149F7"/>
</svg>
